import gridView from '@/global/components/grid/GridView.vue'
import CellIcon from '../../../../fleet-module/vehicles/components/main-table/CellIcon.vue'
import { deleteAction } from '@/global/components/table/helpers/tableActions'
import partnerDetailsMixin from '../../mixins/partnerDetailsMixin'

const TAB_KEY = 'partnerLocations'
export default {
  name: 'sessionTab',

  mixins: [
    partnerDetailsMixin
  ],

  computed: {
    partnerLocationsEditConfig () {
      return {
        title: this.$t('administration.partner_locations'),
        key: TAB_KEY,
        onTabChange: () => {
          this.showMainEditButtons = false
        },
        tabContent: [
          {
            component: this.tableGridComponent,
            editable: false,
            apiConfig: {
              get: {
                module: 'administration',
                route: `partners/${this.$route.params.id}/locations`
              }
            },
            gridConfig: {
              component: gridView,
              blockConfig: {
                component: () => import('../../components/PartnerLocationsGridBlock.vue')
              },
              useBorder: false
            },
            filters_and_columns_visibility_config: {
              showFiltersButton: false
            },
            tableConfig: {
              cellsConfig: {
                show_on_map: {
                  style: {
                    justifyItems: 'center'
                  }
                }
              },
              headers: [
                {
                  label: this.$t('administration/partner_location.name'),
                  key: 'name',
                  always_visible: true
                },
                {
                  label: this.$t('administration/address_type.type'),
                  key: 'type',
                  always_visible: true
                },
                {
                  label: this.$t('administration/partner_location.address'),
                  key: 'address',
                  always_visible: true
                },
                {
                  label: this.$t('locations.country'),
                  key: 'country',
                  always_visible: true
                },
                {
                  label: this.$t('locations.city'),
                  key: 'city',
                  always_visible: true
                },
                {
                  label: this.$t('administration/partner_group.group'),
                  key: 'group',
                  always_visible: true
                },
                {
                  label: this.$t('fleet/vehicle.show_on_map'),
                  key: 'show_on_map',
                  style: {
                    width: '100px',
                    textAlign: 'center'
                  },
                  initial_value: true,
                  component: CellIcon,
                  disableDefaultClick: true,
                  always_visible: true,
                  onClick: (event) => this.showPartnerLocationOnMap(event),
                  src: '/img/icons/show-on-map-icon.svg'
                }
              ],
              actionsConfig: [
                { ...deleteAction(this.$t, (event) => this.onPartnerLocationRemove(event)), type: 'delete' }
              ],
              paginationConfig: {
                perPageOptions: [20, 50, 100],
                perPage: 20
              }
            }
          }
        ]
      }
    }
  }
}
